import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

const cryptoNewsHeaders = {
    'X-BingApis-SDK': 'true',
    'X-RapidAPI-Host': 'bing-news-search1.p.rapidapi.com',
    'X-RapidAPI-Key': '6b49313f0bmsha56947600c406c9p1d41c8jsnefc9c1462047'
}

const baseUrl = "https://bing-news-search1.p.rapidapi.com"

const createRequest = (url) =>({url, headers: cryptoNewsHeaders})

export const cryptoNewsApi = createApi({
    reducerPath: "cryptoNewsApi",
    baseQuery : fetchBaseQuery({baseUrl}),
    endpoints: (builder) =>({
        getCryptoNews : builder.query({
            query : ({newsCategory, count}) =>createRequest(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`)
        })
    })
})

export const { 
    useGetCryptoNewsQuery
} = cryptoNewsApi